import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';

const ReviewQueueTable = ({ jobs, onViewDetail }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  const getStatusReasonBadge = (statusReason) => {
    const badgeMap = {
      'LOOKUP_NO_MATCH': { class: 'bg-warning', text: 'No Match' },
      'LOOKUP_LOW_CONFIDENCE': { class: 'bg-info', text: 'Low Confidence' },
      'LOOKUP_MULTIPLE_MATCHES': { class: 'bg-secondary', text: 'Multiple Matches' },
      'RULE_EXECUTION_ERROR': { class: 'bg-danger', text: 'Execution Error' },
      'REFERENCE_DATA_NOT_LOADED': { class: 'bg-danger', text: 'Data Not Loaded' }
    };

    const badge = badgeMap[statusReason] || { class: 'bg-secondary', text: statusReason };
    return <span className={`badge ${badge.class}`}>{badge.text}</span>;
  };

  return (
    <div className="table-responsive">
      <table className="table table-hover">
        <thead>
          <tr>
            <th>Job ID</th>
            <th>Customer</th>
            <th>Extraction Job ID</th>
            <th>Status Reason</th>
            <th>Created At</th>
            <th>Updated At</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {jobs.map((job) => (
            <tr key={job.id}>
              <td>
                <code className="text-muted small">{job.id}</code>
              </td>
              <td>{job.customerName}</td>
              <td>
                <code className="text-muted small">{job.extractionJobId}</code>
              </td>
              <td>{getStatusReasonBadge(job.statusReason)}</td>
              <td className="text-muted small">{formatDate(job.createdAt)}</td>
              <td className="text-muted small">{formatDate(job.updatedAt)}</td>
              <td>
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => onViewDetail(job)}
                  title="View and resolve"
                >
                  <FontAwesomeIcon icon={faEye} /> Review
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReviewQueueTable;
